import {
  collection,
  query,
  getDocs,
  deleteDoc,
  doc
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";

export const Delete_service_information = async (
  servicetablename,
  tablename
) => {
  const select_company_uid = Cookies.get("select_company_uid");

  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  try {
    const collectionRef = collection(
      db,
      servicetablename,
      select_company_uid,
      tablename
    );

    const q = query(collectionRef);
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      return { success: true, deleted: 0 };
    }

    const deletePromises = snapshot.docs.map((docSnap) =>
      deleteDoc(doc(db, servicetablename, select_company_uid, tablename, docSnap.id))
    );

    await Promise.all(deletePromises);

    return {
      success: true,
      deleted: snapshot.size,
    };
  } catch (err) {
    return {
      success: false,
      error: err.message || "Unknown error",
    };
  }
};
